/* eslint-disable react/prop-types */
import { useCallback } from "react";
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Grid,
	Slide
} from "@mui/material";
import { CustomInput } from "../../../../shared/CustomInput";

import "./customEnterEmailDialog.css";

const CustomEmailDialog = ({ customEmailFormDialogProps, enteredEmail, setEnteredEmail, emailHealthCardHandler }) => {
	const { openDialog, title, actions } = customEmailFormDialogProps;

	const handleEnteredEmailChange = useCallback(
		// eslint-disable-next-line arrow-parens
		(event) => {
			const { value } = event.target;
			setEnteredEmail(value);
		},
		[setEnteredEmail]
	);

	return (
		<div>
			<Dialog
				style={{ zIndex: 5000, padding: 16 }}
				open={openDialog}
				keepMounted
				aria-labelledby="alert-dialog-slide-title"
				aria-describedby="alert-dialog-slide-description"
				fullWidth
				// maxWidth="xl"
			>
				<DialogTitle id="alert-dialog-slide-title">
					<div className="custom-dialog-title">{title}</div>
				</DialogTitle>
				<DialogContent>
					<div className="custom-email-input-form-container">
						<div className="custom-email-input-label">Enter Email</div>
						<div className="custom-email-input-container">
							<CustomInput
								value={enteredEmail}
								onChange={handleEnteredEmailChange}
								placeholder="Enter your email"
								// style={{ width: "100%" }}
								// onChange={onChange}

								// defaultValue={textfield?.value}
							/>
						</div>
						{/* <CustomInput
							value={enteredEmail}
							onChange={handleEnteredEmailChange}
							placeholder="Enter your email"
							// onChange={onChange}

							// defaultValue={textfield?.value}
						/> */}
					</div>
				</DialogContent>
				<DialogActions>
					{actions?.map((action, index) => {
						const { label, callback } = action;
						return (
							<Button
								variant="contained"
								key={index}
								onClick={callback}
								style={{
									backgroundColor: "#3a4652", //"#44b700" --> Green Color
									letterSpacing: "1px",
									fontSize: "0.7rem",
									fontWeight: "bold",
									color: "#ffff",
									marginRight: 10,
									marginLeft: 5
								}}
							>
								{label}
							</Button>
						);
					})}
					<Button
						variant="contained"
						onClick={emailHealthCardHandler}
						style={{
							backgroundColor: "#3a4652", //"#44b700" --> Green Color
							letterSpacing: "1px",
							fontSize: "0.7rem",
							fontWeight: "bold",
							color: "#ffff",
							marginRight: 10,
							marginLeft: 5
						}}
					>
						Submit
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
};

export default CustomEmailDialog;
